import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

type ToastSnackbarData = {
  title?: string;
  description?: string;
  isError?: boolean;
};

@Component({
  selector: 'app-toast-snackbar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="x--alert-_2291-13769" [class.x--alert--error]="data.isError">
      <div class="icon-container_I2291-13769-6642-19470">
        <img
          class="checkcircleoutlined_I2291-13769-6642-19471"
          [src]="data.isError ? 'assets/images/Error_icon.svg' : 'assets/images/Successful_icon.svg'"
          [alt]="data.isError ? 'Error icon' : 'Success icon'"
          aria-hidden="true"
        />
      </div>

      <div class="text_I2291-13769-6642-19472">
        <span *ngIf="data.title" class="text--title-_I2291-13769-6642-19473">{{ data.title }}</span>
        <span *ngIf="data.description" class="text-description_I2291-13769-6642-19474">{{ data.description }}</span>
      </div>
    </div>
  `,
  styleUrls: ['../../../features/patients/manage-device-assignment/remove-device-snackbar.component.scss'],
})
export class ToastSnackbarComponent {
  readonly data = inject(MAT_SNACK_BAR_DATA) as ToastSnackbarData;
}
